class CustomSelect extends HTMLElement
{
  constructor ()
  {
    super();
    this.selectElement = this.querySelector('select');
    this.labelElement = this.querySelector('label');
    this.wrapperDiv = null;
    this.valueDiv = null;
    this.labelDiv = null;
    this.bodyDiv = null;
    this.optionsDiv = null;
    this.searchDiv = null;
    this.init();
  }

  init ()
  {
    this.wrap();
    this.update();
    this.inputEvent = new Event("input");
    this.selectEvent = new Event("change");

    this.addEventListener('input', e => {
      const form = this.closest('form');

      if (form) {
        form.dispatchEvent(new Event('input'));
      }
    });

    this.addEventListener('change', e => {
      this.selectElement.dispatchEvent(this.selectEvent);
      this.update();
    });

    document.addEventListener('click', e => {
      this.close();
    });

    this.wrapperDiv.addEventListener('click', e => {
      e.stopPropagation();
    });

    this.selectElement.addEventListener('change', e => {
      this.update();
    });

    this.selectElement.addEventListener('modified', e => {
      this.refresh();
    });

    setTimeout(() => {
      this.update()
    }, 100);
  }

  toggle ()
  {
    if (this.wrapperDiv.classList.contains('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open ()
  {
    this.wrapperDiv.classList.add('open');

    const selectedOption = this.optionsDiv.querySelector('.selected');

    if (selectedOption && selectedOption.previousElementSibling) {
      this.optionsDiv.scrollTop = selectedOption.previousElementSibling.offsetTop;
    }
  }

  close ()
  {
    this.wrapperDiv.classList.remove('open');

    if (this.searchDiv) {
      const input = this.searchDiv.querySelector('input');
      input.value = '';
      input.dispatchEvent(new Event('change'));
    }
  }

  wrap ()
  {
    this.wrapperDiv = document.createElement('div');
    this.wrapperDiv.classList.add('custom-select');

    const classesToRemove = [];

    this.classList.forEach(name => {
      this.wrapperDiv.classList.add(name);
      classesToRemove.push(name);
    });

    classesToRemove.forEach(name => {
      this.classList.remove(name);
    });

    this.parentNode.insertBefore(this.wrapperDiv, this);
    this.wrapperDiv.appendChild(this);

    if (this.labelElement) {
      this.labelDiv = document.createElement('div');
      this.labelDiv.classList.add('custom-select-label');
      this.labelDiv.innerHTML = this.labelElement.innerHTML;
      this.wrapperDiv.appendChild(this.labelDiv);
    }

    this.valueDiv = document.createElement('div');
    this.valueDiv.classList.add('custom-select-value');
    this.valueDiv.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      this.toggle();
    });
    this.wrapperDiv.appendChild(this.valueDiv);

    const icon = document.createElement('div');
    icon.classList.add('custom-select-toggle');
    icon.innerHTML = this.getIcon();

    this.wrapperDiv.appendChild(icon);

    this.bodyDiv = document.createElement('div');
    this.bodyDiv.classList.add('custom-select-body');
    this.bodyDiv.addEventListener('click', e => e.stopPropagation());
    this.wrapperDiv.appendChild(this.bodyDiv);

    if (typeof(this.selectElement.dataset.search) !== 'undefined') {
      const placeholder = typeof(this.selectElement.dataset.searchPlaceholder) !== 'undefined'
        ? this.selectElement.dataset.searchPlaceholder
        : 'Search...';
      this.searchDiv = document.createElement('div');
      this.searchDiv.classList.add('custom-select-search');
      this.searchDiv.innerHTML = `<input type="text" placeholder="${placeholder}" /><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.125C15.899 2.125 19.875 6.10104 19.875 11C19.875 15.899 15.899 19.875 11 19.875C6.10104 19.875 2.125 15.899 2.125 11C2.125 6.10104 6.10104 2.125 11 2.125ZM11 18.125C14.936 18.125 18.125 14.936 18.125 11C18.125 7.06295 14.936 3.875 11 3.875C7.06296 3.875 3.875 7.06296 3.875 11C3.875 14.936 7.06295 18.125 11 18.125ZM18.2478 19.485L19.485 18.2478L22.1372 20.899L20.899 22.1372L18.2478 19.485Z" fill="currentColor" stroke="white" stroke-width="0.25"/></svg>`;
      ['change', 'keyup'].forEach(event => this.searchDiv.querySelector('input').addEventListener(event, e => this.search()));
      this.bodyDiv.appendChild(this.searchDiv);
    }

    this.optionsDiv = document.createElement('div');
    this.optionsDiv.classList.add('custom-select-options');
    this.bodyDiv.appendChild(this.optionsDiv);
    this.appendOptions();

    if (this.selectElement.disabled) {
      this.wrapperDiv.classList.add('custom-select-disabled');
    }
  }

  appendOptions ()
  {
    this.optionsDiv.innerHTML = '';

    if (this.selectElement.dataset.optionsSort) {
      const tmpAry = [];

      for (let i = 0; i < this.options.length; i++) {
        tmpAry[i] = [];
        tmpAry[i][0] = this.options[i].text;
        tmpAry[i][1] = this.options[i].value;
      }

      tmpAry.sort();

      while (this.options.length > 0) {
        this.options[0] = null;
      }

      for (let i = 0; i < tmpAry.length; i++) {
        this.options[i] = new Option(tmpAry[i][0], tmpAry[i][1]);
      }
    }

    for (let index = 0; this.selectElement.options.length > index; index++) {
      const option = document.createElement('div');
      option.classList.add('custom-select-option');
      this.selectElement.options[index].classList.forEach(cls => option.classList.add(cls));
      option.dataset.optionIndex = index;
      option.innerHTML = typeof(this.selectElement.options[index].dataset.optionHtml) !== 'undefined'
        ? this.selectElement.options[index].dataset.optionHtml
        : this.selectElement.options[index].innerHTML;

      if (this.selectElement.options[index].disabled) {
        option.classList.add('disabled');
      }

      if (typeof(this.selectElement.options[index].dataset.optionPlaceholder) !== 'undefined') {
        option.classList.add('placeholder');
      }

      option.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        if (option.classList.contains('disabled')) {
          return;
        }

        this.close();

        this.selectElement.value = this.selectElement.querySelectorAll('option')[index].value;
        this.dispatchEvent(new Event('input'));
        this.dispatchEvent(new Event('change'));
      });

      this.optionsDiv.append(option);
    }
  }

  search ()
  {
    const search = this.searchDiv.querySelector('input').value.toLowerCase();

    if (!search) {
      this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => option.classList.remove('hidden'));

      return;
    }

    this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => {
      if (option.textContent.toLowerCase().indexOf(search) > -1) {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    });
  }

  refresh ()
  {
    this.appendOptions();
    this.wrapperDiv.classList.toggle('custom-select-disabled', this.selectElement.disabled);
  }

  update ()
  {
    this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => option.classList.remove('selected'));

    const option = this.optionsDiv.querySelector(`[data-option-index="${this.optionIndex || this.selectElement.options.selectedIndex}"]`);

    if (option) {
      option.classList.add('selected');

      const div = document.createElement('div');
      option.classList.forEach(cls => div.classList.add(cls));
      div.classList.remove('selected', 'custom-select-option');
      div.innerHTML = option.innerHTML;

      if (div.classList.length > 0) {
        this.valueDiv.innerHTML = '';
        this.valueDiv.appendChild(div);
      } else {
        this.valueDiv.innerHTML = option.innerHTML;
      }
    } else {
      this.valueDiv.innerHTML = '';
    }
  }

  filter (callback)
  {
    let option, div;

    for (let index = 0; this.selectElement.options.length > index; index++) {
      option = this.selectElement.options[index];
      div = this.optionsDiv.querySelector(`[data-option-index="${index}"]`);

      if (option) {
        if (callback(option, div)) {
          div.style.display = '';
        } else {
          div.style.display = 'none';
        }
      }
    }
  }

  getIcon ()
  {
    if (this.querySelector('.custom-select-icon')) {
      return this.querySelector('.custom-select-icon').innerHTML;
    }

    return `<svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.43546 11.9087C8.46596 11.9392 8.49017 11.9754 8.50668 12.0152C8.52319 12.0551 8.53169 12.0978 8.53169 12.1409C8.53169 12.184 8.52319 12.2267 8.50668 12.2665C8.49017 12.3064 8.46596 12.3426 8.43546 12.373L4.49796 16.3105C4.46748 16.341 4.43129 16.3652 4.39146 16.3818C4.35163 16.3983 4.30893 16.4068 4.26581 16.4068C4.22269 16.4068 4.17999 16.3983 4.14016 16.3818C4.10032 16.3652 4.06413 16.341 4.03366 16.3105L0.0961592 12.373C0.0345896 12.3115 -1.71641e-09 12.228 0 12.1409C1.71641e-09 12.0538 0.0345896 11.9703 0.0961592 11.9087C0.157729 11.8472 0.241235 11.8126 0.328308 11.8126C0.41538 11.8126 0.498887 11.8472 0.560456 11.9087L4.26581 15.6141L7.97116 11.9087C8.00163 11.8782 8.03782 11.854 8.07765 11.8375C8.11749 11.821 8.16019 11.8125 8.20331 11.8125C8.24643 11.8125 8.28913 11.821 8.32896 11.8375C8.36879 11.854 8.40498 11.8782 8.43546 11.9087ZM0.560456 4.49803L4.26581 0.79268L7.97116 4.49803C8.00165 4.52852 8.03784 4.5527 8.07767 4.5692C8.1175 4.5857 8.16019 4.59419 8.20331 4.59419C8.24642 4.59419 8.28911 4.5857 8.32895 4.5692C8.36878 4.5527 8.40497 4.52852 8.43546 4.49803C8.46594 4.46755 8.49012 4.43135 8.50662 4.39152C8.52312 4.35169 8.53162 4.309 8.53162 4.26588C8.53162 4.22277 8.52312 4.18008 8.50662 4.14025C8.49012 4.10041 8.46594 4.06422 8.43546 4.03373L4.49796 0.0962347C4.46748 0.0657268 4.43129 0.0415247 4.39146 0.025012C4.35163 0.00849939 4.30893 0 4.26581 0C4.22269 0 4.17999 0.00849939 4.14016 0.025012C4.10032 0.0415247 4.06413 0.0657268 4.03366 0.0962347L0.0961592 4.03373C0.065673 4.06422 0.0414904 4.10041 0.0249914 4.14025C0.0084924 4.18008 0 4.22277 0 4.26588C0 4.309 0.0084924 4.35169 0.0249914 4.39152C0.0414904 4.43135 0.065673 4.46755 0.0961592 4.49803C0.126645 4.52852 0.162838 4.5527 0.20267 4.5692C0.242502 4.5857 0.285194 4.59419 0.328308 4.59419C0.371422 4.59419 0.414114 4.5857 0.453946 4.5692C0.493778 4.5527 0.52997 4.52852 0.560456 4.49803Z" fill="currentColor" /></svg>`;
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', CustomSelect);
}